import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from './components/toaster/toaster';
import { MetadataService } from './services/metadata/metadata';
import { TranslationService } from './services/translation/translation';

@Component({
  selector: 'nr-root',
  imports: [RouterOutlet, ToasterComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly document = inject(DOCUMENT);
  private readonly metadataService = inject(MetadataService);
  private readonly titleService = inject(Title);
  private readonly translationService = inject(TranslationService);

  constructor() {
    effect(() => {
      const lang = this.translationService.lang();
      if (!lang) return;
      this.document.documentElement.lang = lang;
      const resourceTitle = this.metadataService.resourceTitle();
      if (resourceTitle) this.titleService.setTitle(resourceTitle.getTranslation(lang));
    });
  }
}
